import React, { useState } from "react";
import { BASE_URL } from "../env";
import axios from "axios";
// import { CSVReader } from "react-papaparse";
// import QuestionCSV from "../Assets/img/QuestionCSV.png";
import { store } from "react-notifications-component";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
const buttonRef = React.createRef();
const QuizEditForm = () => {
	const { id } = useParams();
	const [question, setquestion] = useState("");
	const [questionType, setquestiontype] = useState("");
	const [questionPic, setquestionpic] = useState("");
	const [answerSelectionType, setanswerselectiontype] = useState("");
	const [ansArr, setansArr] = useState([{ answer: "" }]);
	const [correctAnswer, setcorrectanswer] = useState("");
	const [msgforcorrectans, setmsgforcorrectans] = useState("");
	const [msgforincorrectans, setmsgforincorrectans] = useState("");
	const [explanation, setexplanation] = useState("");
	const [point, setpoint] = useState(0);
	const [timer, settimer] = useState("");
	const [topic, settopic] = useState("");
	const [answer, setans] = useState("");
	const [ansImage, setAnsImage] = useState([]);
	const [isImageAns, setIsImageAns] = useState(false);
	const [isTextAns, setIsTextAns] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [uploadedImages, setUploadedImages] = useState([]);
	const [CSVdata, setCSVdata] = useState("");
	const [doneuploading, setdoneuploading] = useState(false);
	// const { CSVReader } = useCSVReader();

	// useEffect(() => {
	// 	fetch(BASE_URL + "/getQuestionquiz/" + id, {
	// 		method: "GET",
	// 		headers: {
	// 			"Content-type": "application/json",
	// 		},
	// 	})
	// 		.then((res) => res.json())
	// 		.then((data) => {
	// 			setquestion(data.data.question);
	// 			setquestiontype(data.data.questionType);
	// 			setcorrectanswer(data.data.correctAnswer[0]);
	// 			setmsgforcorrectans(data.data.messageForCorrectAnswer);
	// 			setmsgforincorrectans(data.data.messageForIncorrectAnswer);
	// 			setanswerselectiontype(data.data.answerSelectionType);
	// 			let oneanswerarray = [];
	// 			setansArr(oneanswerarray);
	// 			setpoint(parseInt(data.data.marks));
	// 			setexplanation(data.data.explanation);
	// 			settimer(data.data.timer);
	// 			setquestionpic(data.data.questionPic);
	// 			setanswerselectiontype(data.data.answerSelectionType);
	// 			settopic(data.data.topic);
	// 		});
	// }, [id]);

	useEffect(() => {
		fetch(BASE_URL + "/getQuestionquiz/" + id, {
			method: "GET",
			headers: {
				"Content-type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				//    console.log(data);
				setquestion(data.data.question);
				setquestiontype(data.data.questionType);
				//    console.log(data.data.correctAnswer)
				setcorrectanswer(data.data.correctAnswer[0]);
				setmsgforcorrectans(data.data.messageForCorrectAnswer);
				setmsgforincorrectans(data.data.messageForIncorrectAnswer);
				setanswerselectiontype(data.data.answerSelectionType);
				const newarray = data.data.answers;
				let oneanswerarray = [];
				const anotherarray = newarray.map((value) => {
					oneanswerarray.push({
						answer: value,
					});
				});
				setansArr(oneanswerarray);
				setpoint(parseInt(data.data.marks));
				setexplanation(data.data.explanation);
				settimer(data.data.timer);
				setquestionpic(data.data.questionPic);
				setanswerselectiontype(data.data.answerSelectionType);
				settopic(data.data.topic);
			});
	}, [id]);

	// function AddQuestion(data) {
	// 	const finalJSON = {
	// 		answers: data[0].split("~,~"),
	// 		question: data[1],
	// 		questionType: data[2],
	// 		questionPic: data[3],
	// 		answerSelectionType: data[4],
	// 		correctAnswer: data[5],
	// 		messageForCorrectAnswer: data[6],
	// 		messageForIncorrectAnswer: data[7],
	// 		explanation: data[8],
	// 		timer: data[9],
	// 		point: data[10],
	// 		topic: data[11],
	// 	};
	// 	const notifyPopup = () => {
	// 		store.addNotification({
	// 			title: "Success!",
	// 			message: "Form Submitted Successfully!",
	// 			type: "success",
	// 			background: "pink",
	// 			insert: "bottom",
	// 			container: "bottom-right",
	// 			animationIn: ["animate__animated", "animate__fadeIn"],
	// 			animationOut: ["animate__animated", "animate__fadeOut"],
	// 			dismiss: {
	// 				duration: 3000,
	// 				onScreen: true,
	// 			},
	// 		});
	// 	};

	// 	fetch(BASE_URL + "/createQuestionSchema/", {
	// 		method: "POST",
	// 		headers: {
	// 			"Content-Type": "Application/json",
	// 		},
	// 		body: JSON.stringify(finalJSON),
	// 	})
	// 		.then((res) => res.json())
	// 		.then((data) => {
	// 			notifyPopup();
	// 			setquestion("");
	// 			setquestiontype("");
	// 			setquestionpic("");
	// 			setanswerselectiontype("");
	// 			setansArr([{ answer: "" }]);
	// 			setcorrectanswer("");
	// 			setmsgforcorrectans("");
	// 			setmsgforincorrectans("");
	// 			setexplanation("");
	// 			setpoint("");
	// 			settimer("");
	// 			settopic("");
	// 			setans("");
	// 			setAnsImage([]);
	// 			setIsImageAns(false);
	// 			setIsTextAns(false);
	// 			setUploaded(false);
	// 			setUploadedImages([]);
	// 			setCSVdata("");
	// 		})
	// 		.catch((err) => console.log(err));
	// }

	const ImageUploadHandler = async () => {
		var ImageData = new FormData();
		ImageData.append("answers", ansImage[0]);
		ImageData.append("answers", ansImage[1]);
		ImageData.append("answers", ansImage[2]);
		ImageData.append("answers", ansImage[3]);
		const res = await axios.post(BASE_URL + "/uploadAnsImages", ImageData, {
			headers: { "Content-Type": "application/json" },
		});
		console.log(res.data.message);
		setUploaded(!uploaded);
		setUploadedImages(res.data.message);
	};

	const submitHandler = async () => {
		var formData = new FormData();

		formData.append("question", question);
		formData.append("questionType", questionType);
		// formData.append("questionPic", questionPic);
		formData.append("correctAnswer", correctAnswer);
		formData.append("answerSelectionType", answerSelectionType);
		formData.append("messageForCorrectAnswer", msgforcorrectans);
		formData.append("messageForIncorrectAnswer", msgforincorrectans);
		formData.append("explanation", explanation);
		formData.append("marks", point);
		formData.append("timer", timer);
		formData.append("topic", topic);
		if (isImageAns) {
			// console.log("isImageAns",isImageAns);
			formData.append("answers", uploadedImages);
		}
		if (isTextAns) {
			// console.log("isTextAns",isTextAns);
			formData.append("answers", ansArr.slice(1, ansArr.length));
		}

		const newarray = ansArr.map((value) => value.answer);
		// const response = await axios.post(
		//   BASE_URL + "/createQuestionSchema",
		//   formData,
		//   {
		//     headers: { "Content-Type": "application/json" },
		//   }
		// );
		// console.log("Response After Submitting the Form!", response);
		fetch(BASE_URL + "/editthequestion/" + id, {
			method: "POST",
			headers: {
				"Content-Type": "Application/json",
			},
			body: JSON.stringify({
				answers: isImageAns ? uploadedImages : newarray,
				question: question,
				questionType: questionType,
				// questionPic: questionPic,
				answerSelectionType: answerSelectionType,
				correctAnswer: correctAnswer,
				messageForCorrectAnswer: msgforcorrectans,
				messageForIncorrectAnswer: msgforincorrectans,
				explanation: explanation,
				point: point,
				timer: timer,
				topic: topic,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				if (data.message == "updated") {
					alert("updated");
					setdoneuploading(!doneuploading);
				}
				if (data.success == true) {
					alert(data.success);
					window.location.reload();
				}
				console.log(data);
			})
			.catch((err) => console.log(err));
	};

	const handleAddFields = () => {
		setansArr((prev) => [...prev, answer]);
	};

	return (
		<div className="mx-auto p-5 form-control quiz-container">
			<h2 style={{ textAlign: "center" }}>Quiz Question Form</h2>
			<br />
			<br />
			<div>
				<label htmlFor="question">Question:</label>{" "}
				<textarea
					type="text"
					className="form-control"
					value={question}
					onChange={(e) => setquestion(e.target.value)}
					id="question"
					placeholder="Question"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="questiontype">Question Type:</label>{" "}
				<textarea
					type="text"
					placeholder="Question Type"
					value={questionType}
					className="form-control"
					onChange={(e) => setquestiontype(e.target.value)}
					id="questiontype"
				/>
			</div>
			<br />
			<br />
			<div></div>
			<label htmlFor="questionpic">Question Pic:</label>{" "}
			<input
				type="text"
				//   value={questionPic}
				placeholder="questionpic"
				className="form-control"
				onChange={(e) => setquestionpic(e.target.value)}
				id="questionpic"
				// onChange={(e) => setquestion(e.target.value)}
			/>
			<br />
			<br />
			<div>
				<label htmlFor="AnswerSelectionType">
					Answer Selection Type:
				</label>{" "}
				<select
					placeholder="AnswerSelection Type"
					className="dropdown btn btn-dark"
					value={answerSelectionType}
					onChange={(e) => setanswerselectiontype(e.target.value)}
					id="AnswerSelectionType"
				>
					<option value="null">Choose One</option>
					<option value="single choice">Single Choice</option>
					<option value="multiple choice">Multiple Choice</option>
				</select>
			</div>
			<br />
			<br />
			<div>
				<button
					className="btn btn-primary"
					onClick={() => {
						setIsImageAns(!isImageAns);
						setIsTextAns(false);
					}}
				>
					Upload Ans as Image?
				</button>
				<button
					className="btn btn-primary"
					onClick={() => {
						setIsTextAns(!isTextAns);
						setIsImageAns(false);
					}}
				>
					Upload Ans as Text?
				</button>
			</div>
			{isImageAns ? (
				<div>
					<label htmlFor="ans_image">Answers as Pictures</label>
					<input
						type="file"
						multiple
						placeholder="Choose Multiple Images"
						className="form-control"
						onChange={(e) => {
							setAnsImage(e.target.files);
						}}
						id="ans_image"
						name="ans_image"
					/>
					<button
						onClick={() => {
							ImageUploadHandler();
						}}
						className="btn btn-dark"
					>
						Upload
					</button>
					{uploaded
						? uploadedImages.map((item, index) => {
								return (
									<>
										<table class="table table-striped">
											<tbody>
												<tr>
													<th className="text-dark">
														{++index}
													</th>
													<td>{item}</td>
												</tr>
											</tbody>
										</table>
									</>
								);
						  })
						: null}
				</div>
			) : null}
			{isTextAns ? (
				<div>
					<label htmlFor="ansArr">
						Answer Array:(Add answer and cllick save, keep last
						input field as blank)
					</label>
					{ansArr.map((inputField, index) => (
						<div key={inputField.id}>
							<br />
							<p>Answer:</p>
							<textarea
								name="AnswerArray"
								placeholder="Answer Array"
								className="form-control"
								id="ansArr"
								value={inputField.answer}
								onChange={(event) => {
									let newarray = ansArr;
									newarray[index] = {
										answer: event.target.value,
									};
									setansArr([...newarray]);
								}}
							/>
							<br />
							&emsp;
							<button
								className="btn btn-sm btn-success"
								onClick={handleAddFields}
							>
								Save
							</button>
							<button
								className="btm btn-sm btn-danger"
								onClick={() => {
									const newarray = ansArr;
									let another = newarray.filter(
										(value, idx2) => idx2 !== index
									);
									setansArr(another);
								}}
							>
								Delete
							</button>
							&emsp;
							{/* <button
              // disabled={inputFields.length === 1}
              className="btn btn-sm btn-danger"
              onClick={() => handleRemoveFields(ansArr.id)}
            >
              Remove this Field
            </button> */}
						</div>
					))}
				</div>
			) : null}
			<br />
			<div>
				<label htmlFor="correctanswer">Correct Answer:</label>
				<textarea
					value={correctAnswer}
					type="text"
					placeholder="Correct Answer"
					className="form-control"
					onChange={(e) => setcorrectanswer(e.target.value)}
					id="correctanswer"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="msgforcorrectans">
					Message For Correct Answer:
				</label>
				<textarea
					value={msgforcorrectans}
					type="text"
					placeholder="Message For Correct Answer"
					className="form-control"
					onChange={(e) => setmsgforcorrectans(e.target.value)}
					id="msgforcorrectans"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="msgforincorrectans">
					Message For Incorrect Answer:
				</label>
				<input
					value={msgforincorrectans}
					type="text"
					placeholder="Message For Incorrect Answer"
					className="form-control"
					onChange={(e) => setmsgforincorrectans(e.target.value)}
					id="msgforincorrectans"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="explanation">Explanation:</label>{" "}
				<input
					value={explanation}
					type="text"
					placeholder="Explanation"
					className="form-control"
					onChange={(e) => setexplanation(e.target.value)}
					id="explanation"
				/>
			</div>
			<br />
			<div>
				<label htmlFor="point">Point:</label>{" "}
				<input
					value={point}
					type="number"
					placeholder="Point"
					className="form-control"
					onChange={(e) => setpoint(parseInt(e.target.value) || 0)}
					id="point"
				/>
			</div>
			<br />
			<div>
				<label htmlFor="timer">Timer:</label>{" "}
				<input
					value={timer}
					type="text"
					placeholder="Timer"
					className="form-control"
					onChange={(e) => settimer(e.target.value)}
					id="timer"
				/>
			</div>
			<br />
			<div>
				<label htmlFor="topic">Topic:</label>
				<input
					type="text"
					value={topic}
					placeholder="Topic"
					className="form-control"
					onChange={(e) => settopic(e.target.value)}
					id="topic"
				/>
			</div>
			<br />
			<br />
			<button
				className="btn btn-lg btn-primary"
				onClick={() => submitHandler()}
			>
				Submit
			</button>
			{/* </form> */}
		</div>
	);
};

export default QuizEditForm;
